import { http } from '@/utils'
import type {
  ResGetUserBenefit,
  ResGetIntegralDetailItemInfo,
  ResCommon,
  ResGetIntegralRechargeInfo,
} from '@/api/type/result'
import type { ResGetCreditConsumption } from '@/api/type/other'
const integralApi = {
  // 获取用户积分
  getUserBenefit: () => {
    return http.get<void, ResGetUserBenefit>('user_benefit')
  },
  // 获取积分消耗
  getIntegralConsumption: () => {
    return http.get<void, ResGetCreditConsumption>('user_benefit/credit_consumption')
  },
  // 获取积分消耗详情
  getIntegralConsumptionDetail: () => {
    return http.get<void, ResGetIntegralDetailItemInfo>('user_benefit/credit_consumption_detail')
  },
  // 获取积分充值
  getIntegralRecharge: () => {
    return http.get<void, ResGetIntegralRechargeInfo>('product-pack')
  },
}

export default integralApi
